/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, generatePath, useHistory } from 'react-router-dom';
// @ts-ignore
import { Card } from '@els/els-react--card';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
// @ts-ignore
import { SingleSelect } from '@els/els-react--select';
// @ts-ignore
import { Flyout } from '@els/els-react--flyout';
// @ts-ignore
import { Button, ButtonWithIcon } from '@els/els-react--button';
// @ts-ignore
import { Modal } from '@els/els-react--modal';
// @ts-ignore
import { Banner } from '@els/els-react--banner';
import { HSearchContentType, SkillsTabIndexes } from '../../constants/h-search';
import PrintTab from '../../utils/print-tab/print-tab';
import Routes from '../../constants/routes';
import PatientEducationContent from './patient-education-content/patient-education-content';
import { selectHSCSContentAsyncStatus } from './search-selector';
import {
    hasFailed,
    hasSucceeded,
    isPending,
} from '../../../libs/utils/constants/async-status';
import { FEATURE_FLAGS } from '../../../libs/utils/constants/feature-flag';
import { selectClientFeatureFlags } from '../login/login-selector';
import {
    selectAppConfigs,
    selectAppRuntimeConfigsAsyncStatus,
} from '../app-config/app-config-selector';
import { ISkillTabs } from '../../../libs/utils/interfaces/skill-launch-interface';
import {
    createSelfEnrollment,
    getEnrolledSkill,
    cancelSelfEnrollment,
} from './self-enrollment/self-enrollment-thunk';
import {
    COURSE_CONTENT_TYPE,
    SELF_ENROLLMENT_STATUS,
} from '../../constants/self-enrollment';
import {
    selectCreateSelfEnrollmentAsyncStatus,
    selectCancelSelfEnrollmentAsyncStatus,
    selectCurrentEnrolledSkillId,
    selectEnrolledSkillAsyncStatus,
    selectEnrolledSkillsAsyncStatus,
    selectEventSelfEnrolledCourseId,
} from './self-enrollment/self-enrollment-selector';
import {
    setCurrentEnrolledSkillId,
    resetSelfEnrollmentState,
    setEventSelfEnrolledCourseId,
} from './self-enrollment/self-enrollment-slice';

const ENROLLED_DROPDOWN_OPTIONS = Object.freeze([
    {
        value: 'start-learning',
        label: 'Start learning',
    },
    {
        value: 'view-my-learning',
        label: 'View in my learning',
    },
    {
        value: 'cancel-enrollment',
        label: 'Cancel enrollment',
    },
]);

const SearchedSkillCard = (props: any) => {
    const {
        baseClassName,
        cardType,
        title,
        description,
        searchedSkillId,
        allActiveSkillsDetails,
        courseContentType,
        // isUserAdmin,  will be used in CLH Phase 4
        eid,
        languageCode,
        spanishLanguageId,
        quickLinks,
        quickLinksAsyncStatus,
        CE,
        saveSearchState,
        counts,
        hasCE,
        selfEnrollment,
        setOverlayLoaderVisible,
        setShowCancelSuccessToast,
        index,
    } = props;

    const componentRef = useRef(null);
    const mobileFooterRef = useRef<HTMLDivElement | null>(null);
    const history = useHistory();
    const dispatch = useDispatch<any>();
    const hscsAsyncStatus = useSelector(selectHSCSContentAsyncStatus);
    const [isPrintTabVisible, setIsPrintTabVisible] = useState(false);
    const [isPrintLoading, setIsPrintLoading] = useState(false);
    const [enrolledButtonWidth, setEnrolledButtonWidth] = useState('20.5rem');
    const [enrolledDropdownKey, setEnrolledDropdownKey] = useState(0);
    const [isSelfEnrollModalOpen, setIsSelfEnrollModalOpen] = useState(false);
    const [
        isSelfEnrolledConfirmationModalOpen,
        setIsSelfEnrolledConfirmationModalOpen,
    ] = useState(false);
    const [isCancelEnrollmentModalOpen, setIsCancelEnrollmentModalOpen] =
        useState(false);
    const [isMobileEnrolledFlyoutOpen, setIsMobileEnrolledFlyoutOpen] =
        useState(false);
    const [selectedSkill, setSelectedSkill] = useState('');
    const [isSelfEnrollmentStatusLoading, setIsSelfEnrollmentStatusLoading] =
        useState(false);
    const [enrolledSkillFetchFailed, setEnrolledSkillFetchFailed] =
        useState(false);
    const refreshButtonRef = useRef<HTMLButtonElement>(null);
    const shouldRestoreRefreshFocus = useRef(false);

    const { ecrId } = useParams<{ ecrId: string }>();

    const clientFeatureFlags = useSelector(selectClientFeatureFlags);
    const appConfigs = useSelector(selectAppConfigs);
    const appRuntimeConfigsAsyncStatus = useSelector(
        selectAppRuntimeConfigsAsyncStatus
    );
    const enrolledSkillsAsyncStatus = useSelector(
        selectEnrolledSkillsAsyncStatus
    );
    const createSelfEnrollmentAsyncStatus = useSelector(
        selectCreateSelfEnrollmentAsyncStatus
    );
    const cancelSelfEnrollmentAsyncStatus = useSelector(
        selectCancelSelfEnrollmentAsyncStatus
    );
    const currentEnrolledSkillId = useSelector(selectCurrentEnrolledSkillId);
    const enrolledSkillAsyncStatus = useSelector(
        selectEnrolledSkillAsyncStatus
    );
    const eventSelfEnrolledCourseId = useSelector(
        selectEventSelfEnrolledCourseId
    );

    const courseId = allActiveSkillsDetails?.find(
        (activeSkill: { courseIdentifier: string }) =>
            activeSkill.courseIdentifier === searchedSkillId
    )?.id;

    const isCurrentCard = currentEnrolledSkillId === courseId;
    const showCreateEnrollmentError =
        isCurrentCard && hasFailed(createSelfEnrollmentAsyncStatus);
    const showCancelEnrollmentError =
        isCurrentCard && hasFailed(cancelSelfEnrollmentAsyncStatus);
    const isCreateEnrollmentPending =
        isCurrentCard && isPending(createSelfEnrollmentAsyncStatus);
    const isCancelEnrollmentPending =
        isCurrentCard && isPending(cancelSelfEnrollmentAsyncStatus);

    const renderInlineError = (message: string) => (
        <p className={`${baseClassName}__inline-error`} role="alert">
            <Icon
                sprite={Icon.Sprites.ALERT_SOLID_SQUARE}
                size="s"
                color="warn"
                isDecorative
            />
            <span className="u-els-color-warn">{message}</span>
        </p>
    );

    const handlePrintClick = (data: boolean, language: string) => {
        sessionStorage.setItem('peQueryParamsEid', eid);
        sessionStorage.setItem('peQueryParamsSpanishId', spanishLanguageId);
        sessionStorage.setItem(
            'peQueryParamsLanguageCode',
            language === 'english' ? 'eng' : 'es'
        );
        setIsPrintTabVisible(data);
        setIsPrintLoading(false);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getPrintHref = (_language: string) => '#';

    useEffect(() => {
        if (hasSucceeded(hscsAsyncStatus)) {
            setIsPrintLoading(true);
        }
    }, [hscsAsyncStatus]);

    useEffect(() => {
        const setButtonWidth = () => {
            const enrolledButtonElement =
                mobileFooterRef.current?.querySelector(
                    `.${baseClassName}__content-section__card__mobile-enrolled-button`
                ) as HTMLElement | null;
            const width = enrolledButtonElement?.getBoundingClientRect().width;
            if (width) {
                setEnrolledButtonWidth(`${Math.ceil(width) - 30}px`);
            }
        };
        setButtonWidth();
        window.addEventListener('resize', setButtonWidth);

        return () => {
            window.removeEventListener('resize', setButtonWidth);
        };
    }, [baseClassName, selfEnrollment]);

    useEffect(() => {
        if (
            currentEnrolledSkillId === courseId &&
            hasSucceeded(createSelfEnrollmentAsyncStatus)
        ) {
            dispatch(
                getEnrolledSkill({
                    skillIds: [courseId],
                })
            );
            setIsSelfEnrollModalOpen(false);
            setIsSelfEnrolledConfirmationModalOpen(true);
        }
    }, [currentEnrolledSkillId, createSelfEnrollmentAsyncStatus]);

    useEffect(() => {
        if (
            currentEnrolledSkillId === courseId &&
            hasFailed(createSelfEnrollmentAsyncStatus)
        ) {
            setOverlayLoaderVisible(false);
            setIsSelfEnrollmentStatusLoading(false);
        }
    }, [currentEnrolledSkillId, createSelfEnrollmentAsyncStatus]);

    useEffect(() => {
        if (
            currentEnrolledSkillId === courseId &&
            hasSucceeded(cancelSelfEnrollmentAsyncStatus)
        ) {
            setOverlayLoaderVisible(false);
            setIsCancelEnrollmentModalOpen(false);
            setIsMobileEnrolledFlyoutOpen(false);
            setShowCancelSuccessToast(true);
            dispatch(
                getEnrolledSkill({
                    skillIds: [courseId],
                })
            );
            setSelectedSkill('');
        }
    }, [currentEnrolledSkillId, cancelSelfEnrollmentAsyncStatus]);

    useEffect(() => {
        if (
            currentEnrolledSkillId === courseId &&
            hasFailed(cancelSelfEnrollmentAsyncStatus)
        ) {
            setOverlayLoaderVisible(false);
            setIsSelfEnrollmentStatusLoading(false);
        }
    }, [currentEnrolledSkillId, cancelSelfEnrollmentAsyncStatus]);

    useEffect(() => {
        const hasEnrolledSkillSettled =
            hasSucceeded(enrolledSkillAsyncStatus) ||
            hasFailed(enrolledSkillAsyncStatus);

        if (currentEnrolledSkillId === courseId && hasEnrolledSkillSettled) {
            setIsSelfEnrollmentStatusLoading(false);
            setOverlayLoaderVisible(false);
            setEnrolledSkillFetchFailed(hasFailed(enrolledSkillAsyncStatus));
            dispatch(resetSelfEnrollmentState());
        }
        if (eventSelfEnrolledCourseId === courseId) {
            setIsSelfEnrollmentStatusLoading(true);
        }
        if (eventSelfEnrolledCourseId === courseId && hasEnrolledSkillSettled) {
            setIsSelfEnrollmentStatusLoading(false);
            setEnrolledSkillFetchFailed(hasFailed(enrolledSkillAsyncStatus));
            dispatch(setEventSelfEnrolledCourseId({ courseId: null }));
            dispatch(resetSelfEnrollmentState());
        }
    }, [
        currentEnrolledSkillId,
        eventSelfEnrolledCourseId,
        enrolledSkillAsyncStatus,
    ]);

    useEffect(() => {
        // A successful list fetch gives this card fresh status, so a stale
        // per-card error must not keep the CTA hidden.
        if (hasSucceeded(enrolledSkillsAsyncStatus)) {
            setEnrolledSkillFetchFailed(false);
        }
    }, [enrolledSkillsAsyncStatus]);

    useEffect(() => {
        if (enrolledSkillFetchFailed && shouldRestoreRefreshFocus.current) {
            shouldRestoreRefreshFocus.current = false;
            refreshButtonRef.current?.focus();
        }
    }, [enrolledSkillFetchFailed]);

    useEffect(() => {
        if (
            eventSelfEnrolledCourseId === courseId &&
            isSelfEnrollmentStatusLoading
        ) {
            dispatch(
                getEnrolledSkill({
                    skillIds: [courseId],
                })
            );
        }
    }, [eventSelfEnrolledCourseId, isSelfEnrollmentStatusLoading]);

    const handleOnTitleClick = () => {
        const courseId = allActiveSkillsDetails?.find(
            (activeSkill: { courseIdentifier: string }) =>
                activeSkill.courseIdentifier === searchedSkillId
        )?.id;
        const redirectLink = generatePath(Routes.SKILL_LAUNCH, {
            id: courseId,
            ecrId,
        });
        saveSearchState();
        history.push(`${redirectLink}/`);
        window.scrollTo(0, 0);
    };

    // Using this function to generate href for Link component
    const getTitleHref = () => {
        const courseId = allActiveSkillsDetails?.find(
            (activeSkill: { courseIdentifier: string }) =>
                activeSkill.courseIdentifier === searchedSkillId
        )?.id;
        if (!courseId) return '';
        return `${generatePath(Routes.SKILL_LAUNCH, {
            id: courseId,
            ecrId,
        })}/`;
    };

    const skillQuickLink = courseId
        ? quickLinks?.find((quickLink: any) => quickLink.courseId === courseId)
        : undefined;

    const shift = !skillQuickLink?.notes ? -1 : 0;

    const handleOnQuickLinkClick = (tab: keyof ISkillTabs) => {
        if (!courseId) return;
        saveSearchState();
        const redirectLink = generatePath(Routes.SKILL_LAUNCH, {
            id: courseId,
            ecrId,
        });
        history.push(
            `${redirectLink}#tab-${Number(SkillsTabIndexes[tab]) + shift}`
        );
        window.scrollTo(0, 0);
    };

    // Using this function to generate href for Link component
    const getQuickLinkHref = (tab: keyof ISkillTabs) => {
        if (!courseId) return '';
        return `${generatePath(Routes.SKILL_LAUNCH, {
            id: courseId,
            ecrId,
        })}#tab-${Number(SkillsTabIndexes[tab]) + shift}`;
    };

    const handleRedirectToPEContentDetails = (
        eid: string,
        languageCode: string,
        spanishLanguageId: string
    ) => {
        const redirectLink = `${generatePath(Routes.PATIENT_EDUCATION, {
            ecrId,
        })}`;
        sessionStorage.setItem('peQueryParamsEid', eid);
        sessionStorage.setItem('peQueryParamsLanguageCode', languageCode);
        sessionStorage.setItem('peQueryParamsSpanishId', spanishLanguageId);
        history.push(`${redirectLink}`);
        window.scrollTo(0, 0);
    };

    // Using this function to generate href for Link component
    const getPEContentHref = () =>
        `${generatePath(Routes.PATIENT_EDUCATION, { ecrId })}`;

    const handleOnClickPatientEducation = (
        eid: string,
        languageCode: string,
        spanishLanguageId: string
    ) => {
        saveSearchState();
        handleRedirectToPEContentDetails(eid, languageCode, spanishLanguageId);
    };

    const handleSelfEnrollment = () => {
        dispatch(setCurrentEnrolledSkillId({ skillId: courseId }));
        dispatch(
            createSelfEnrollment({
                courseId,
                hasCE,
            })
        );
        setIsSelfEnrollmentStatusLoading(true);
        setOverlayLoaderVisible(true);
    };

    const handleSelfEnrollmentCancel = () => {
        setIsSelfEnrollModalOpen(false);
        setSelectedSkill('');
        dispatch(resetSelfEnrollmentState());
    };

    const handleSelfEnrolledConfirmationClose = () => {
        setIsSelfEnrolledConfirmationModalOpen(false);
        setSelectedSkill('');
    };

    const handleOpenCancelEnrollmentModal = () => {
        dispatch(resetSelfEnrollmentState());
        setIsMobileEnrolledFlyoutOpen(false);
        setSelectedSkill(title);
        setIsCancelEnrollmentModalOpen(true);
    };

    const handleCloseCancelEnrollmentModal = () => {
        setIsMobileEnrolledFlyoutOpen(false);
        setIsCancelEnrollmentModalOpen(false);
        setSelectedSkill('');
        dispatch(resetSelfEnrollmentState());
    };

    const handleRefreshEnrollmentStatus = () => {
        // The banner unmounts while the retry is in flight, so remember to
        // put focus back on the refresh icon if the retry fails again.
        shouldRestoreRefreshFocus.current = true;
        setEnrolledSkillFetchFailed(false);
        setIsSelfEnrollmentStatusLoading(true);
        dispatch(setCurrentEnrolledSkillId({ skillId: courseId }));
        dispatch(
            getEnrolledSkill({
                skillIds: [courseId],
            })
        );
    };

    const handleConfirmCancelEnrollment = () => {
        setShowCancelSuccessToast(false);
        dispatch(setCurrentEnrolledSkillId({ skillId: courseId }));
        setOverlayLoaderVisible(true);
        setIsSelfEnrollmentStatusLoading(true);
        dispatch(
            cancelSelfEnrollment({
                selfEnrollmentId: selfEnrollment?.selfEnrollmentId,
            })
        );
    };

    const handleSelfEnrollClick = () => {
        // Clear any error left by a previous attempt so a freshly opened
        // modal never starts out showing a stale failure message.
        dispatch(resetSelfEnrollmentState());
        setIsSelfEnrollModalOpen(true);
        setSelectedSkill(title);
    };

    const handleKeyPress = (
        event: React.KeyboardEvent<HTMLDivElement>,
        callback: () => void
    ) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callback();
        }
    };

    const desktopEnrollmentLabel = `Enrollment actions for ${title}`;

    const enrolledDropdownId = `enrolled-dropdown-${index}`;
    const desktopSelfEnrollButtonId = `self-enroll-${index}`;
    const mobileEnrolledButtonId = `mobile-enrolled-${index}`;
    const mobileSelfEnrollButtonId = `mobile-self-enroll-${index}`;

    const setEnrollmentSelectRef = useCallback(() => {}, []);

    const handleEnrollmentAction = (action: string) => {
        setIsMobileEnrolledFlyoutOpen(false);

        switch (action) {
            case 'start-learning':
                window.open(
                    `${appConfigs.CONNECT_ADAPTER_BASE_URL}/launch?lessonId=${courseId}&selfEnrollmentId=${selfEnrollment?.selfEnrollmentId}`,
                    'connect adapter link',
                    'width=1200,height=1000'
                );
                break;
            case 'view-my-learning':
                window.open(
                    `${appConfigs.NEURON_BASE_URL}/my-learning/self-enrolled-skills`,
                    '_blank',
                    'noopener,noreferrer'
                );
                break;
            case 'cancel-enrollment':
                handleOpenCancelEnrollmentModal();
                break;
            default:
                break;
        }
    };

    const handleViewMyLearningClick = () => {
        handleEnrollmentAction('view-my-learning');
        handleSelfEnrolledConfirmationClose();
    };

    const handleStartLearningClick = () => {
        handleEnrollmentAction('start-learning');
        handleSelfEnrolledConfirmationClose();
    };

    const handleEnrolledDropdownChange = (option: {
        label: string;
        value: string;
    }) => {
        handleEnrollmentAction(option.value);
        setEnrolledDropdownKey((prev) => prev + 1);
    };

    const renderMobileEnrolledFlyout = useCallback(
        () => (
            <div>
                <div
                    className={`${baseClassName}__content-section__card__mobile-enrolled-flyout-panel`}
                >
                    {ENROLLED_DROPDOWN_OPTIONS.map((option) => (
                        <button
                            key={option.value}
                            type="button"
                            onClick={() => handleEnrollmentAction(option.value)}
                            className={`${baseClassName}__content-section__card__mobile-enrolled-flyout-action`}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>
        ),
        [baseClassName, handleEnrollmentAction]
    );

    const hasEnrolledSkillsListFailed = hasFailed(enrolledSkillsAsyncStatus);

    const isCardMenuLoading =
        (!hasSucceeded(enrolledSkillsAsyncStatus) &&
            !hasEnrolledSkillsListFailed) ||
        isSelfEnrollmentStatusLoading ||
        !hasSucceeded(appRuntimeConfigsAsyncStatus);

    const renderLoaderForCardMenu = () =>
        clientFeatureFlags[FEATURE_FLAGS.ENABLE_SELF_ENROLMENT] &&
        isCardMenuLoading && (
            <div
                className={`${baseClassName}__content-section__card__header-right-loader`}
            >
                <Loader isVisible isBlocking={false} isSmall />
            </div>
        );

    // The enrollment CTA stays hidden while this shows - its label comes from
    // the status we failed to fetch, so it could offer the wrong action.
    const renderEnrollmentStatusErrorBanner = () =>
        clientFeatureFlags[FEATURE_FLAGS.ENABLE_SELF_ENROLMENT] &&
        !isCardMenuLoading &&
        !hasEnrolledSkillsListFailed &&
        cardType === HSearchContentType.CLINICALSKILLS &&
        enrolledSkillFetchFailed && (
            <Banner
                className={`${baseClassName}__content-section__card__enrollment-status-error`}
                isVisible
                isFilled
                type="warn"
            >
                <span
                    className={`${baseClassName}__content-section__card__enrollment-status-error__message`}
                >
                    We were unable to fetch your self-enrollment status. Please
                    try fetching the self-enrollment status again using this
                    refresh icon.
                </span>
                <ButtonWithIcon
                    ref={refreshButtonRef}
                    type="borderless"
                    size="small"
                    iconOnly
                    onClick={handleRefreshEnrollmentStatus}
                    onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) =>
                        handleKeyPress(event, handleRefreshEnrollmentStatus)
                    }
                    sprite={Icon.Sprites.SYNC}
                >
                    {`Refresh enrollment status for ${title}`}
                </ButtonWithIcon>
            </Banner>
        );

    return (
        <Card className={`${baseClassName}__content-section__card`}>
            {renderEnrollmentStatusErrorBanner()}
            <div className={`${baseClassName}__content-section__card__header`}>
                <div
                    className={`${baseClassName}__content-section__card__header-left`}
                >
                    {cardType === HSearchContentType.CLINICALSKILLS && (
                        <>
                            <Icon
                                a11y={{
                                    name: 'stethoscope',
                                }}
                                textAlignment="bottom"
                                size="s"
                                className="stethoscope-icon"
                                sprite={Icon.Sprites.STETHOSCOPE}
                                aria-label="stethoscope"
                            />
                            <span>Type: Clinical skill</span>
                        </>
                    )}
                    {cardType === HSearchContentType.PATIENTEDUCATION && (
                        <>
                            <Icon
                                a11y={{
                                    name: 'books',
                                }}
                                textAlignment="bottom"
                                size="s"
                                className="books-icon"
                                sprite={Icon.Sprites.BOOKS}
                                aria-label="books"
                            />
                            <span>Type: Patient education</span>
                        </>
                    )}
                </div>

                <div
                    className={`${baseClassName}__content-section__card__header-right`}
                >
                    {renderLoaderForCardMenu()}
                    {clientFeatureFlags[FEATURE_FLAGS.ENABLE_SELF_ENROLMENT] &&
                        !isCardMenuLoading &&
                        !hasEnrolledSkillsListFailed &&
                        !enrolledSkillFetchFailed &&
                        cardType === HSearchContentType.CLINICALSKILLS &&
                        ([
                            SELF_ENROLLMENT_STATUS.NOT_STARTED,
                            SELF_ENROLLMENT_STATUS.IN_PROGRESS,
                        ].includes(selfEnrollment?.status) &&
                        !selfEnrollment?.isTestCompleted ? (
                            <div
                                className={`${baseClassName}__content-section__card__enrolled-wrapper`}
                            >
                                <Icon
                                    sprite={
                                        Icon.Sprites.CONFIRMATION_OUTLINE_CIRCLE
                                    }
                                    size="s"
                                    color="positive"
                                    a11y={{ name: 'enrolled' }}
                                />
                                <SingleSelect
                                    key={enrolledDropdownKey}
                                    options={ENROLLED_DROPDOWN_OPTIONS}
                                    selectedOptions={[]}
                                    size="small"
                                    inputRef={setEnrollmentSelectRef}
                                    isPlainInput
                                    label={desktopEnrollmentLabel}
                                    onSelect={handleEnrolledDropdownChange}
                                    optionsFlyoutProps={{
                                        placement: 'bottom-end',
                                        width: '12rem',
                                    }}
                                    required
                                    hideRequired
                                    shouldHideLabel
                                    shouldSelectionWrap
                                    placeholderText="Enrolled"
                                    blankOptionLabel="Enrolled"
                                    tabIndex={0}
                                    id={enrolledDropdownId}
                                    className={`${baseClassName}__content-section__card__enrolled-dropdown`}
                                    aria-label="enrolled"
                                />
                            </div>
                        ) : (
                            <ButtonWithIcon
                                onClick={handleSelfEnrollClick}
                                onKeyPress={(
                                    event: React.KeyboardEvent<HTMLDivElement>
                                ) =>
                                    handleKeyPress(event, handleSelfEnrollClick)
                                }
                                size="small"
                                tabIndex={0}
                                id={desktopSelfEnrollButtonId}
                                aria-label={
                                    selfEnrollment?.status ===
                                    SELF_ENROLLMENT_STATUS.COMPLETED
                                        ? 'Re enroll'
                                        : 'Self enroll'
                                }
                                sprite={Icon.Sprites.PUBLICATION_SET}
                                type="borderless"
                                expanded
                            >
                                {[
                                    SELF_ENROLLMENT_STATUS.COMPLETED,
                                    SELF_ENROLLMENT_STATUS.IN_PROGRESS,
                                ].includes(selfEnrollment?.status)
                                    ? 'Re-enroll'
                                    : 'Self-enroll'}
                            </ButtonWithIcon>
                        ))}
                    {/* <Icon
                        a11y={{
                            name: 'star',
                        }}
                        textAlignment="bottom"
                        size="xs"
                        className="star-icon"
                        sprite={Icon.Sprites.STAR}
                        aria-label="star"
                    />
                    <span className="favorite-text" tabIndex={0} id="content">Favorite</span>
                    <Icon
                        a11y={{
                            name: 'email',
                        }}
                        textAlignment="bottom"
                        size="xs"
                        className="email-icon"
                        sprite={Icon.Sprites.EMAIL}
                        aria-label="email"
                    />
                    <span className="email-text" tabIndex={0} id="content">Email</span> */}
                </div>
            </div>

            {cardType === HSearchContentType.PATIENTEDUCATION && (
                <div
                    className={`${baseClassName}__content-section__card__title`}
                >
                    <LinkElement
                        aria-label={`Result ${counts.index} of ${counts.total}, ${title}`}
                        href={getPEContentHref()}
                        inline
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            handleOnClickPatientEducation(
                                eid,
                                languageCode,
                                spanishLanguageId
                            );
                        }}
                    >
                        {title}
                    </LinkElement>
                </div>
            )}
            {cardType === HSearchContentType.CLINICALSKILLS && (
                <div
                    className={`${baseClassName}__content-section__card__title`}
                >
                    <LinkElement
                        aria-label={`Result ${counts.index} of ${counts.total}, ${title}`}
                        href={getTitleHref()}
                        inline
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            handleOnTitleClick();
                        }}
                    >
                        {title}
                    </LinkElement>
                </div>
            )}
            <div
                className={`${baseClassName}__content-section__card__description`}
            >
                <p>{description}</p>
            </div>
            {cardType === HSearchContentType.CLINICALSKILLS &&
                hasSucceeded(quickLinksAsyncStatus) && (
                    <div
                        className={`${baseClassName}__content-section__card__footer`}
                    >
                        {skillQuickLink?.notes && (
                            <span>
                                <LinkElement
                                    inline
                                    href={getQuickLinkHref('Notes')}
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        handleOnQuickLinkClick('Notes');
                                    }}
                                >
                                    Organization notes
                                </LinkElement>
                            </span>
                        )}
                        {skillQuickLink?.quickSheet && (
                            <span>
                                <LinkElement
                                    inline
                                    href={getQuickLinkHref('QuickSheet')}
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        handleOnQuickLinkClick('QuickSheet');
                                    }}
                                >
                                    Quick sheet
                                </LinkElement>
                            </span>
                        )}
                        {skillQuickLink?.extendedText && (
                            <span>
                                <LinkElement
                                    inline
                                    href={getQuickLinkHref('ExtendedText')}
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        handleOnQuickLinkClick('ExtendedText');
                                    }}
                                >
                                    Extended text
                                </LinkElement>
                            </span>
                        )}
                        {skillQuickLink?.video && (
                            <span>
                                <LinkElement
                                    inline
                                    href={getQuickLinkHref('Videos')}
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        handleOnQuickLinkClick('Videos');
                                    }}
                                >
                                    Video
                                </LinkElement>
                            </span>
                        )}
                        {skillQuickLink?.illustrations && (
                            <span>
                                <LinkElement
                                    inline
                                    href={getQuickLinkHref('Illustrations')}
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        handleOnQuickLinkClick('Illustrations');
                                    }}
                                >
                                    Illustrations
                                </LinkElement>
                            </span>
                        )}
                    </div>
                )}
            {cardType === HSearchContentType.PATIENTEDUCATION && (
                <div
                    className={`${baseClassName}__content-section__card__footer`}
                >
                    <div
                        className={`${baseClassName}__content-section__card__footer__language-tag`}
                    >
                        <Button
                            href={getPrintHref('english')}
                            type={Button.Types.LINK}
                            className="print-button"
                            onClick={() => {
                                handlePrintClick(true, 'english');
                            }}
                        >
                            <Icon
                                sprite={Icon.Sprites.PRINTER}
                                size="xs"
                                className="print-button-icon"
                                a11y={{ name: `Print ${title} in` }}
                            />
                            <span className="print-btn-text">English</span>
                        </Button>
                    </div>
                    <div
                        className={`${baseClassName}__content-section__card__footer__language-tag`}
                    >
                        <Button
                            href={getPrintHref('spanish')}
                            type={Button.Types.LINK}
                            className="print-button"
                            onClick={() => {
                                handlePrintClick(true, 'spanish');
                            }}
                        >
                            <Icon
                                sprite={Icon.Sprites.PRINTER}
                                size="xs"
                                className="printer-icon"
                                a11y={{ name: `Print ${title} in` }}
                            />
                            <span className="print-btn-text">Spanish</span>
                        </Button>
                    </div>
                </div>
            )}
            {/* This code will be used in CLH Phase 4 */}
            <div
                ref={mobileFooterRef}
                className={`${baseClassName}__content-section__card__footer__mobile`}
            >
                {renderLoaderForCardMenu()}
                {clientFeatureFlags[FEATURE_FLAGS.ENABLE_SELF_ENROLMENT] &&
                    !isCardMenuLoading &&
                    !hasEnrolledSkillsListFailed &&
                    !enrolledSkillFetchFailed &&
                    cardType === HSearchContentType.CLINICALSKILLS &&
                    ([
                        SELF_ENROLLMENT_STATUS.NOT_STARTED,
                        SELF_ENROLLMENT_STATUS.IN_PROGRESS,
                    ].includes(selfEnrollment?.status) &&
                    !selfEnrollment?.isTestCompleted ? (
                        <Flyout
                            flyout={renderMobileEnrolledFlyout()}
                            className={`${baseClassName}__content-section__card__enrolled-dropdown-mobile`}
                            onToggle={(state: boolean) =>
                                setIsMobileEnrolledFlyoutOpen(state)
                            }
                            shouldCloseOnESC
                            trigger="click"
                            placement="bottom"
                            pointer
                            noInternalPadding
                            width={enrolledButtonWidth}
                        >
                            <Button
                                type="secondary"
                                size="small"
                                expanded
                                tabIndex={0}
                                className={`${baseClassName}__content-section__card__mobile-enrolled-button c-els-button--icon`}
                                id={mobileEnrolledButtonId}
                                aria-label="enrolled"
                            >
                                <Icon
                                    sprite={
                                        Icon.Sprites.CONFIRMATION_OUTLINE_CIRCLE
                                    }
                                    size="s"
                                    color="positive"
                                    isDecorative
                                    textAlignment={Icon.TextAlignment.OFFSET}
                                />
                                <span className="c-els-button__text">
                                    <span>Enrolled</span>
                                    <Icon
                                        sprite={
                                            isMobileEnrolledFlyoutOpen
                                                ? Icon.Sprites.CHEVRON_UP
                                                : Icon.Sprites.CHEVRON_DOWN
                                        }
                                        size="xs"
                                        className={`${baseClassName}__content-section__card__mobile-enrolled-button-chevron`}
                                        a11y={{
                                            name: 'enrollment actions menu',
                                        }}
                                    />
                                </span>
                            </Button>
                        </Flyout>
                    ) : (
                        <ButtonWithIcon
                            type="tertiary"
                            onClick={handleSelfEnrollClick}
                            onKeyPress={(
                                event: React.KeyboardEvent<HTMLDivElement>
                            ) => handleKeyPress(event, handleSelfEnrollClick)}
                            expanded
                            size="small"
                            tabIndex={0}
                            id={mobileSelfEnrollButtonId}
                            aria-label={
                                selfEnrollment?.status ===
                                SELF_ENROLLMENT_STATUS.COMPLETED
                                    ? 'Re enroll'
                                    : 'Self enroll'
                            }
                            sprite={Icon.Sprites.PUBLICATION_SET}
                        >
                            {[
                                SELF_ENROLLMENT_STATUS.COMPLETED,
                                SELF_ENROLLMENT_STATUS.IN_PROGRESS,
                            ].includes(selfEnrollment?.status)
                                ? 'Re-enroll'
                                : 'Self-enroll'}
                        </ButtonWithIcon>
                    ))}
                {/* <Button
                    type="tertiary"
                    onClick={() => {}}
                    expanded
                    size="small"
                    className="__favorite"
                >
                    <Icon
                        a11y={{
                            name: 'star',
                        }}
                        textAlignment="bottom"
                        size="s"
                        className="star-icon"
                        sprite={Icon.Sprites.STAR}
                        aria-label="star"
                    />
                    Favorite
                </Button>
                <Button
                    type="tertiary"
                    onClick={() => {}}
                    expanded
                    size="small"
                    className="__email"
                >
                    <Icon
                        a11y={{
                            name: 'email',
                        }}
                        textAlignment="bottom"
                        size="s"
                        className="email-icon"
                        sprite={Icon.Sprites.EMAIL}
                        aria-label="email"
                    />
                    Email
                </Button> */}
            </div>
            {isSelfEnrollModalOpen && (
                <Modal
                    onClose={handleSelfEnrollmentCancel}
                    onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) =>
                        handleKeyPress(event, handleSelfEnrollmentCancel)
                    }
                    id="modal-id"
                    width="510px"
                    type="secondary"
                    label="Confirm self-enrollment"
                >
                    {courseContentType ===
                        COURSE_CONTENT_TYPE.CLIENT_CUSTOMIZED_SKILLS ||
                    courseContentType ===
                        COURSE_CONTENT_TYPE.INSTITUTIONAL_SUPPLIED_SKILL ? (
                        <div className={`${baseClassName}__self-enroll-modal`}>
                            <div
                                className={`${baseClassName}__self-enroll-modal__header`}
                            >
                                <h3>Confirm self-enrollment</h3>
                            </div>
                            <div
                                className={`${baseClassName}__self-enroll-modal__body`}
                            >
                                <p>
                                    <strong>
                                        Continuing education not available
                                    </strong>
                                </p>
                                <p
                                    className={`${baseClassName}__self-enroll-modal__body__disclaimer`}
                                >
                                    This skill was created or customized by your
                                    organization. Because of this, completing it
                                    will not award continuing education (CE)
                                    credit.
                                </p>
                                <p
                                    className={`${baseClassName}__self-enroll-modal__body__disclaimer`}
                                >
                                    You can still enroll and complete this skill
                                    for learning or practice.
                                </p>
                            </div>
                            <div
                                className={`${baseClassName}__self-enroll-modal__footer`}
                            >
                                <Button
                                    type="secondary"
                                    onClick={handleSelfEnrollmentCancel}
                                    onKeyPress={(
                                        event: React.KeyboardEvent<HTMLDivElement>
                                    ) =>
                                        handleKeyPress(
                                            event,
                                            handleSelfEnrollmentCancel
                                        )
                                    }
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleSelfEnrollment}
                                    disabled={isCreateEnrollmentPending}
                                    onKeyPress={(
                                        event: React.KeyboardEvent<HTMLDivElement>
                                    ) =>
                                        handleKeyPress(
                                            event,
                                            handleSelfEnrollment
                                        )
                                    }
                                >
                                    Enroll without CE credit
                                </Button>
                            </div>
                            {showCreateEnrollmentError &&
                                renderInlineError(
                                    'We could not enroll you. Please try again.'
                                )}
                        </div>
                    ) : (
                        <div className={`${baseClassName}__self-enroll-modal`}>
                            <div
                                className={`${baseClassName}__self-enroll-modal__header`}
                            >
                                <h3>Confirm self-enrollment</h3>
                            </div>
                            <div
                                className={`${baseClassName}__self-enroll-modal__body`}
                            >
                                <p>
                                    {`Are you sure you want to self-enroll in ${selectedSkill}?`}
                                </p>
                                <p>
                                    <strong>{`Eligible CE: ${CE} credits`}</strong>
                                </p>
                                <p
                                    className={`${baseClassName}__self-enroll-modal__body__disclaimer`}
                                >
                                    There are no due dates, you can earn
                                    continuing education (CE) credits, and the
                                    skill will appear on your My Learning page
                                    for you to complete at your own pace.
                                </p>
                            </div>
                            <div
                                className={`${baseClassName}__self-enroll-modal__footer`}
                            >
                                <Button
                                    type="secondary"
                                    onClick={handleSelfEnrollmentCancel}
                                    onKeyPress={(
                                        event: React.KeyboardEvent<HTMLDivElement>
                                    ) =>
                                        handleKeyPress(
                                            event,
                                            handleSelfEnrollmentCancel
                                        )
                                    }
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleSelfEnrollment}
                                    disabled={isCreateEnrollmentPending}
                                    onKeyPress={(
                                        event: React.KeyboardEvent<HTMLDivElement>
                                    ) =>
                                        handleKeyPress(
                                            event,
                                            handleSelfEnrollment
                                        )
                                    }
                                >
                                    Yes, self-enroll
                                </Button>
                            </div>
                            {showCreateEnrollmentError &&
                                renderInlineError(
                                    'We could not enroll you. Please try again.'
                                )}
                        </div>
                    )}
                </Modal>
            )}
            {isSelfEnrolledConfirmationModalOpen && (
                <Modal
                    onClose={handleSelfEnrolledConfirmationClose}
                    onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) =>
                        handleKeyPress(
                            event,
                            handleSelfEnrolledConfirmationClose
                        )
                    }
                    id="self-enrolled-confirmation-modal-id"
                    type="secondary"
                    label="Self-enrolled confirmation"
                >
                    <div
                        className={`${baseClassName}__self-enrolled-confirmation-modal`}
                    >
                        <div
                            className={`${baseClassName}__self-enrolled-confirmation-modal__header`}
                        >
                            <Icon
                                sprite={
                                    Icon.Sprites.CONFIRMATION_OUTLINE_CIRCLE
                                }
                                size="s"
                                color="positive"
                                isDecorative
                                className={`${baseClassName}__self-enrolled-confirmation-modal__header-icon`}
                            />
                            <h3>Self-enrolled!</h3>
                        </div>
                        <div
                            className={`${baseClassName}__self-enrolled-confirmation-modal__body`}
                        >
                            <p>{`You've self-enrolled in ${selectedSkill}.`}</p>
                            <p>
                                You can start learning now, view in My Learning
                                page, or close this window.
                            </p>
                        </div>
                        <div
                            className={`${baseClassName}__self-enrolled-confirmation-modal__footer`}
                        >
                            <Button
                                type="secondary"
                                expanded
                                onClick={handleViewMyLearningClick}
                                onKeyPress={(
                                    event: React.KeyboardEvent<HTMLDivElement>
                                ) =>
                                    handleKeyPress(
                                        event,
                                        handleViewMyLearningClick
                                    )
                                }
                            >
                                View in My learning
                            </Button>
                            <Button
                                expanded
                                onClick={handleStartLearningClick}
                                onKeyPress={(
                                    event: React.KeyboardEvent<HTMLDivElement>
                                ) =>
                                    handleKeyPress(
                                        event,
                                        handleStartLearningClick
                                    )
                                }
                            >
                                Start learning
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
            {isCancelEnrollmentModalOpen && (
                <Modal
                    onClose={handleCloseCancelEnrollmentModal}
                    onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) =>
                        handleKeyPress(event, handleCloseCancelEnrollmentModal)
                    }
                    id="cancel-enrollment-modal-id"
                    type="neutral"
                    label="Cancel self-enrollment"
                >
                    <div
                        className={`${baseClassName}__cancel-enrollment-modal`}
                    >
                        <div
                            className={`${baseClassName}__cancel-enrollment-modal__header`}
                        >
                            <h3>{`Cancel enrollment in ${selectedSkill}`}</h3>
                        </div>
                        <div
                            className={`${baseClassName}__cancel-enrollment-modal__body`}
                        >
                            <p>
                                Canceling will remove this skill from your
                                learning plan.
                            </p>
                            <p>You can enroll again at any time.</p>
                        </div>
                        <div
                            className={`${baseClassName}__cancel-enrollment-modal__footer`}
                        >
                            <Button
                                type="destructive"
                                onClick={handleCloseCancelEnrollmentModal}
                                onKeyPress={(
                                    event: React.KeyboardEvent<HTMLDivElement>
                                ) =>
                                    handleKeyPress(
                                        event,
                                        handleCloseCancelEnrollmentModal
                                    )
                                }
                            >
                                Stay enrolled
                            </Button>
                            <Button
                                type="secondary"
                                onClick={handleConfirmCancelEnrollment}
                                disabled={isCancelEnrollmentPending}
                                onKeyPress={(
                                    event: React.KeyboardEvent<HTMLDivElement>
                                ) =>
                                    handleKeyPress(
                                        event,
                                        handleConfirmCancelEnrollment
                                    )
                                }
                            >
                                Cancel enrollment
                            </Button>
                        </div>
                        {showCancelEnrollmentError &&
                            renderInlineError(
                                "We couldn't unenroll you. Try again."
                            )}
                    </div>
                </Modal>
            )}
            {isPrintTabVisible && (
                <div className="print-only" ref={componentRef}>
                    <PatientEducationContent />
                </div>
            )}
            {isPending(hscsAsyncStatus) && isPrintTabVisible && (
                <Loader
                    isVisible
                    isBlocking
                    className={`${baseClassName}__print-loader`}
                />
            )}

            {hasSucceeded(hscsAsyncStatus) &&
                isPrintTabVisible &&
                isPrintLoading && (
                    <PrintTab
                        printTabRef={componentRef}
                        callback={handlePrintClick}
                    />
                )}
        </Card>
    );
};

export default SearchedSkillCard;
